import _, { get } from "lodash";
import PropTypes from "prop-types";
import React, { memo, useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getSortingValues } from "../../Constants.js";
import { GNCapi } from "../../services/GNCapi.js";
import ChatBotAI from "../AI/ChatBot.jsx";
import CustomModal from "../CustomModal.jsx";
import CustomOffCanvasThree from "../CustomOffCanvasThree.jsx";
import Spinner from "../Spinner.jsx";
import CompleteTableData from "../Table/CompleteTableData.jsx";
import "./features.common.styles.scss";
import { severityClassMap, getSeverityLabel } from "./helpers.js";
import { BasescorematricsSBOMApi } from "../../../Modules/SBOM/pages/SBOMSlice.js";
import DrillDownAccordion from "../../../Modules/governance-and-compliance/Compliance/Vulnerabilites/DrillDownAccordionModal.js";

const DrillDownOffCanvasThree = (props) => {
  const {
    Loading = false,
    getLimitResource,
    getPageResource,
    handleOnSortingResDrill,
    headerSortingState,
    tableLoading,
    classNameOffcanvas,
    isDI,
  } = props;

  const pageLimitresource = get(props, "pageLimit", 10);
  const ResourcePageNumber = get(props, "curentPageNumber", 0);
  const ResourcefinalPageCount = get(props, "totalPageCount", 0);
  const ResourcelistCount = get(props, "listCount", 0);
  const dispatch = useDispatch();
  const { common } = useSelector((state) => state);
  const commonSliceState = useSelector((state) => state.common);
  const selectedData = get(
    commonSliceState,
    "offcanvasThreeState.selectedData",
    []
  );
  const selectedOneData = [
    get(commonSliceState, "offcanvasThreeState.selectedOneData", []),
  ];
  const [state, setState] = useState({
    modalBodyManage: false,
    modalAccordian: false,
    pluginIdToShow: "",
    cvssScoreToShow: "",
    version: "",
    csvData: [],
    epss: " ",
  });
  const [epssMap, setEpssMap] = useState({});
  const [epssSeverity, setEpssSeverity] = useState();

  const [csvData, setcsvData] = useState([{}]);
  const [enableSpinner, setEnableSpinner] = useState(false);
  const [getCVSSv2Data] = GNCapi.useGetCVSSv2DataMutation();
  const [getCVSSv3Data] = GNCapi.useGetCVSSv3DataMutation();
  const [getEPSSscore] = GNCapi.useGetEPSSscoreMutation();

  const handleEpssScore = (cveId) => {
    if (epssMap[cveId]) {
      return;
    }

    getEPSSscore(cveId)
      .unwrap()
      .then((data) => {
        const epss = Number(data.epss);
        setEpssSeverity(data.epssSeverity);
        setEpssMap((prev) => ({
          ...prev,
          [cveId]: epss && _.isNumber(epss) ? epss.toFixed(4) : data.epss,
        }));
      })
      .catch((error) => {
        console.error("Error fetching EPSS score:", error);
      });
  };

  const modalBodyManage = (article, clause) => {
    return (
      <>
        <h4>{article}</h4>
        <div>{clause}</div>
      </>
    );
  };
  const handleShowAccordian = (
    VulIdToShow,
    BaseScoreShow,
    version,
    ip,
    scanId
  ) => {
    setEnableSpinner(true);
    if (version == "cvssV2") {
      getCVSSv2Data({ pluginId: VulIdToShow, ip, scanId })
        .unwrap()
        .then((data) => {
          setcsvData(data);
          setEnableSpinner(false);
        })
        .catch((err) => setEnableSpinner(false));
    }
    if (version == "cvssV3") {
      getCVSSv3Data({ pluginId: VulIdToShow, ip, scanId })
        .unwrap()
        .then((data) => {
          setcsvData(data);
          setEnableSpinner(false);
        })
        .catch((err) => setEnableSpinner(false));
    }
    if (version == "Base Score") {
      dispatch(BasescorematricsSBOMApi({ id: VulIdToShow }))
        .unwrap()
        .then((data) => {
          setcsvData(data);
          setEnableSpinner(false);
        })
        .catch((err) => setEnableSpinner(false));
    }
    setState({
      ...state,
      modalAccordian: true,
      pluginIdToShow: VulIdToShow,
      cvssScoreToShow: BaseScoreShow,
      version,
    });
  };
  useEffect(() => { }, [state.pluginIdToShow]);
  const accordionFalse = () => {
    setState({
      ...state,
      modalAccordian: false,
      pluginIdToShow: "",
      cvssScoreToShow: "",
      version: "",
    });
    setcsvData([{}]);
  };
  const handleShowManage = () => {
    setState({
      ...state,
      modalBodyManage: true,
    });
  };
  const handleCloseManage = () => {
    setState({
      ...state,
      modalBodyManage: false,
    });
  };

  if (selectedData != [""]) {
    console.log();
  } else {
    console.log();
  }

  const selectedDrillData = get(
    commonSliceState,
    "offcanvasThreeState.selectedData.selectedData",
    []
  );
  const selectedKey = get(
    commonSliceState,
    "offcanvasThreeState.selectedData.jiraKey",
    []
  );
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [selectedFeatureIndex, setSelectedFeatureIndex] = useState(null);

  const handleFeatureClick = (featureName, featureIndex) => {
    setSelectedFeature(featureName);
    setSelectedFeatureIndex(featureIndex);
  };
  useEffect(() => {
    if (!common.offcanvasThreeState.isDrilldownThreeOpen) {
      setSelectedFeature(null);
      setSelectedFeatureIndex(null);
    }
  }, [common.offcanvasThreeState.isDrilldownThreeOpen]);

  function convertEpochTimeToMilliseconds(epochTime) {
    if (epochTime > 1e12) {
      return epochTime;
    } else {
      const epochTimeInMilliseconds = epochTime * 1000;
      return epochTimeInMilliseconds;
    }
  }
  const EpochtoDate = (givenDate) => {
    return new Date(convertEpochTimeToMilliseconds(givenDate)).toLocaleString(
      "en-IN",
      {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }
    );
  };

  if (
    common.offcanvasThreeState.title == "LEVEL OF COLLABORATION BY COMMENTS"
  ) {
    const features = Object.keys(selectedDrillData).map((key) => {
      return {
        name: key,
        count: selectedDrillData[key].length,
      };
    });
    const dDDefaultLevelOne = [
      {
        className: "flowbox dark-blueline dark-blueline",
      },
      {
        className: "flowbox dark-Orange",
      },
      {
        className: "flowbox dark-blueline pinkline",
      },
      {
        className: "flowbox dark-blueline purpleline",
      },
      {
        className: "flowbox dark-blueline yellowline ",
      },
      {
        className: "flowbox dark-blueline orangeline",
      },
    ];

    const filteredData = selectedDrillData[selectedFeature] || [];
    const sortedData = [...filteredData].sort((a, b) => {
      const aValue = new Date(a.timeStamp).getTime();
      const bValue = new Date(b.timeStamp).getTime();

      // Sort in descending order (LIFO) based on timestamp
      if (aValue > bValue) {
        return -1;
      }
      if (aValue < bValue) {
        return 1;
      }
      return 0;
    });
    return (
      <>
        <CustomOffCanvasThree className="custom-off-canvas drilldownThree padding25 pluginDetails">
          <div className="meantimewrap custom_scroll">
            <h4 className="LocIssueTittle">{selectedKey}</h4>
            <div className="flowbox-row distribute-wrap flowacti-block">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className={`${dDDefaultLevelOne[index].className} ${selectedFeatureIndex === index ? "active" : ""
                    }`}
                  onClick={() => handleFeatureClick(feature.name, index)}
                >
                  <h4>{feature.name}</h4>
                  <h2 className="fdcount">{feature.count}</h2>
                </div>
              ))}
            </div>

            {features.length === 0 ? (
              <div className="projectemty">No Data Available</div>
            ) : (
              <div className="flow-descriptions-block flowpredi-des ">
                <div className="stories-list">
                  <h5>{selectedFeature}</h5>
                  <table className="summary_header" id="VTC_summary">
                    <thead>
                      <tr>
                        <th className="width10">Sl.No</th>
                        <th className="width60">Comments</th>
                        <th className="width15">Commented By</th>
                        <th className="width15">Time of Comment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedData.map((data, index) => (
                        <tr key={index}>
                          <td className="text-nowrap px-3">{index + 1}</td>
                          <td>{data.comment}</td>
                          <td>{data.commentBy}</td>
                          <td>
                            {new Date(data.timeStamp).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </CustomOffCanvasThree>
      </>
    );
  } else if (common.offcanvasThreeState.title == "CIS Details") {
    return (
      <>
        <CustomOffCanvasThree className="custom-off-canvas drilldownookThree">
          {Loading ? (
            <Spinner />
          ) : (
            <div className="meantimewrap custom_scroll">
              <div
                className="meanpop-subhead"
                id="comlince_drill_details"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                }}
              >
                <div>
                  <td>
                    {" "}
                    <th className="Plugin-Bold">Plugin Name :</th>
                    <td className="flowhead" id="BusinessInfo_Config">
                      {" "}
                      {selectedOneData.map((data) => (
                        <td key={data} className="p-0">
                          {data && data.pluginName ? data.pluginName : ""}
                        </td>
                      ))}
                    </td>
                  </td>
                  <div>
                    <div className="d-flex" style={{ fontSize: "16px" }}>
                      <td>
                        <th className="Vmlihead">Plugin ID :</th>
                        <td className="Svalue_drill">
                          {selectedOneData.map((data) => (
                            <td key={data} className="p-0">
                              {data && data.pluginId ? data.pluginId : "---"}
                            </td>
                          ))}
                        </td>
                      </td>
                      <td>
                        <th className="Vmlihead">Severity :</th>
                        <td className="Svalue_drill">
                          {selectedOneData.map((data) => (
                            <td key={data} className="p-0 text-capitalize">
                              {getSeverityLabel(data?.severity)}
                            </td>
                          ))}
                        </td>
                      </td>
                    </div>
                  </div>
                </div>
                <div>
                  <ChatBotAI
                    passTitle="Valunerability Management"
                    passPlugin={selectedOneData.map((data) =>
                      data && data.pluginId ? data.pluginId : "Not Available"
                    )}
                    passCVEID={selectedOneData.map((data) =>
                      data && data.cveId
                        ? data.cveId.join(", ")
                        : "Not Available"
                    )}
                    passData={selectedOneData.map((data) =>
                      data && data.synopsis ? data.synopsis : "Not Available"
                    )}
                  />
                </div>
              </div>
              <div className="meanpop-wrap meanpop-subhead">
                {selectedOneData ? (
                  <table>
                    <tbody>
                      <tr>
                        <td className="pluginalign">Audit file</td>
                        <td className="pluginalign">:</td>
                        {selectedOneData.map((data, index) => (
                          <td key={index} className="display-content">
                            {data && data.auditFile ? data.auditFile : "---"}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="pluginalign">Policy value</td>
                        <td className="pluginalign">:</td>
                        {selectedOneData.map((data, index) => (
                          <td key={index} className="display-content">
                            {data && data.policyValue
                              ? data.policyValue
                              : "---"}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="pluginalign">Description</td>
                        <td className="pluginalign">:</td>
                        {selectedOneData.map((data, index) => (
                          <td key={index} className="display-content">
                            {data && data.description
                              ? data.description
                              : "---"}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="pluginalign">Solution</td>
                        <td className="pluginalign">:</td>
                        {selectedOneData.map((data, index) => (
                          <td key={index} className="display-content">
                            {data && data.solution ? data.solution : "---"}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="pluginalign">See also</td>
                        <td className="pluginalign">:</td>
                        {selectedOneData.map((data, index) => (
                          <td key={index} className="display-content">
                            {data && data.seeAlso && data.seeAlso !== "---" ? (
                              <a
                                id="PluginClick"
                                href={data.seeAlso}
                                rel="noreferrer"
                                target="_blank"
                              >
                                {data.seeAlso}
                              </a>
                            ) : (
                              "---"
                            )}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <div className="">No Data Available</div>
                )}
              </div>
            </div>
          )}
        </CustomOffCanvasThree>
      </>
    );
  } else if (common.offcanvasThreeState.title === "Details") {
    const pluginIdToShow = _.get(selectedOneData, "[0].pluginId", "");
    const VulIdToShow = _.get(selectedOneData, "[0].vulnerabilityId", "");
    const BaseScoreShow = _.get(selectedOneData, "[0].baseScore", "");

    const cvssV2ScoreToShow = _.get(selectedOneData, "[0].cvss2Score", "");
    const cvssV3ScoreToShow = _.get(selectedOneData, "[0].cvss3Score", "");
    const scanId = _.get(selectedOneData, "[0].scanId", 0);
    const ip = _.get(selectedOneData, "[0].ip", "");

    return (
      <>
        <CustomOffCanvasThree className="custom-off-canvas drilldownookThree">
          {common.offcanvasThreeState.sbom !== true ? (
            Loading ? (
              <Spinner />
            ) : (
              <div className="meantimewrap custom_scroll">
                <div
                  className="meanpop-subhead "
                  id="comlince_drill_details"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ fontSize: "18px" }}>
                    {" "}
                    <tr>
                      <td>
                        <th className="Plugin-Bold">Plugin Name :</th>
                        <td className="flowhead" id="BusinessInfo_Config">
                          {" "}
                          {selectedOneData.map((data) => (
                            <td key={data} className="p-0 plugin-name-cell" >
                              {data && data.plugInName ? data.plugInName : ""}
                            </td>
                          ))}
                        </td>
                      </td>
                    </tr>
                    <div>
                      <table className="pluginTable">
                        <tr>
                          <td>
                            <span style={{ marginRight: "20px" }}>
                              <th className="Vmlihead">
                                {VulIdToShow
                                  ? "Vulnerability ID :"
                                  : "Plugin ID :"}
                              </th>
                              <td
                                className="Svalue_drill"
                                style={{ marginRight: "20px" }}
                              >
                                {selectedOneData.map((data) => (
                                  <td key={data} className="p-0">
                                    {data && data.pluginId
                                      ? data.pluginId
                                      : "---"}
                                  </td>
                                ))}
                              </td>
                            </span>
                          </td>

                          <td>
                            <th className="Vmlihead">Plugin Family :</th>
                            <td className="Svalue_drill">
                              {_.map(selectedOneData, "pluginFamily")}
                            </td>
                          </td>
                        </tr>
                      </table>
                      <table>
                        <tr>
                          <td>
                            <th className="cvssScoreStyle">CVSS v3 Score :</th>
                            <td className="Svalue_drill clickable_Id">
                              <a
                                onClick={() =>
                                  handleShowAccordian(
                                    pluginIdToShow,
                                    cvssV3ScoreToShow,
                                    "cvssV3",
                                    ip,
                                    scanId
                                  )
                                }
                                style={{ marginRight: "20px" }}
                              >
                                {selectedOneData.map((data) => (
                                  <td key={data} className="p-0">
                                    {data && data.cvss3Score
                                      ? data.cvss3Score
                                      : 0}
                                  </td>
                                ))}
                              </a>
                            </td>
                          </td>
                          {common?.offcanvasThreeState?.hideCVSSv2Score !==
                            true && (
                              <td>
                                <th className="cvssScoreStyle">
                                  CVSS v2 Score :
                                </th>
                                <td className="Svalue_drill clickable_Id">
                                  <a
                                    onClick={() =>
                                      handleShowAccordian(
                                        pluginIdToShow,
                                        cvssV2ScoreToShow,
                                        "cvssV2",
                                        ip,
                                        scanId
                                      )
                                    }
                                    style={{ marginRight: "20px" }}
                                  >
                                    {selectedOneData.map((data) => (
                                      <td key={data} className="p-0">
                                        {data && data.cvss2Score
                                          ? data.cvss2Score
                                          : 0}
                                      </td>
                                    ))}
                                  </a>
                                </td>
                              </td>
                            )}
                          <td>
                            <th className="Vmlihead">Severity :</th>
                            <td
                              className="Svalue_drill"
                              style={{ marginRight: "20px" }}
                            >
                              {selectedOneData.map((data) => (
                                <td key={data} className="p-0 text-capitalize">
                                  {data && data.severity}
                                </td>
                              ))}
                            </td>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div>
                    <ChatBotAI
                      passTitle="Valunerability Management"
                      passPlugin={selectedOneData.map((data) =>
                        data && data.pluginId ? data.pluginId : "Not Available"
                      )}
                      passCVEID={selectedOneData.map((data) =>
                        data && data.cveId ? data.cveId : "Not Available"
                      )}
                      passData={selectedOneData.map((data) =>
                        data && data.synopsis ? data.synopsis : "Not Available"
                      )}
                    />
                  </div>
                </div>
                <div className="meanpop-wrap meanpop-subhead">
                  {selectedOneData ? (
                    <table>
                      <tbody>
                        {selectedOneData.map((data, index) => (
                          <tr key={index}>
                            <td className="pluginalign">CVE ID</td>
                            <td className="pluginalign">:</td>
                            <td className="display-content Svalue_drill">
                              <div className="cveid-grid">
                                {data &&
                                  data.cveId &&
                                  data.cveId.length > 0 &&
                                  data.cveId !== "Not Available" ? (
                                  data.cveId
                                    .split(",")
                                    .map((cveId, cveIndex) => {
                                      const epssScore = epssMap[cveId];
                                      const tooltipClass =
                                        severityClassMap[epssSeverity] || "";
                                      return (
                                        <div
                                          key={cveIndex}
                                          onMouseEnter={() =>
                                            handleEpssScore(cveId)
                                          }
                                        >
                                          {epssScore ? (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={(props) => (
                                                <Tooltip
                                                  {...props}
                                                  className={`tooltip-drill-common ${tooltipClass}`}
                                                  id="tooltip-top"
                                                >
                                                  {`EPSS - ${epssScore}`}
                                                </Tooltip>
                                              )}
                                            >
                                              <span
                                                className="cveIdStyle hover_Id px-2"
                                                style={{ cursor: "pointer" }}
                                              >
                                                {cveId}
                                              </span>
                                            </OverlayTrigger>
                                          ) : (
                                            <span
                                              className="cveIdStyle hover_Id px-2"
                                              style={{ cursor: "pointer" }}
                                            >
                                              {cveId}
                                            </span>
                                          )}
                                        </div>
                                      );
                                    })
                                ) : (
                                  <span className="hover_Id px-2">
                                    Not Available
                                  </span>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}

                        <tr>
                          <td className="pluginalign">Synopsis</td>
                          <td className="pluginalign">:</td>
                          {selectedOneData.map((data, index) => (
                            <td key={index} className="display-content">
                              {data && data.synopsis ? data.synopsis : "---"}
                            </td>
                          ))}
                        </tr>
                        <tr>
                          <td className="pluginalign">Description</td>
                          <td className="pluginalign">:</td>
                          {selectedOneData.map((data, index) => (
                            <td key={index} className="display-content">
                              {data && data.description
                                ? data.description
                                : "---"}
                            </td>
                          ))}
                        </tr>
                        <tr>
                          <td className="pluginalign">Solution</td>
                          <td className="pluginalign">:</td>
                          {selectedOneData.map((data, index) => (
                            <td key={index} className="display-content">
                              {data && data.solution ? data.solution : "---"}
                            </td>
                          ))}
                        </tr>
                        <tr>
                          <td className="pluginalign">Plugin Output</td>
                          <td className="pluginalign">:</td>
                          {selectedOneData?.map((data, index) => (
                            <td key={index} className="display-content" style={{ whiteSpace: "pre-line" }}>
                              {data && data.pluginOutput
                                ? data.pluginOutput
                                  .replace(/^(\\n)+(?=\s*\S)/, "")   // ✅ remove only empty starting lines
                                  .replace(/\\n/g, "\n")
                                  .replace(/\n{2,}/g, "\n")
                                : "---"}
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <div className="">No Data Available</div>
                  )}
                </div>
              </div>
            )
          ) : common.offcanvasThreeState.otherDDComponent ? (
            common.offcanvasThreeState.otherDDComponent
          ) : (
            <div className="meantimewrap custom_scroll">
              <div
                className="meanpop-subhead "
                id="comlince_drill_details"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div style={{ fontSize: "18px" }}>
                  {" "}
                  <tr>
                    <td>
                      <th className="Plugin-Bold">Vulnerability Name :</th>
                      <td className="flowhead" id="BusinessInfo_Config">
                        {" "}
                        {selectedOneData.map((data) => (
                          <td key={data} className="p-0">
                            {data && data?.namespace ? data?.namespace : ""}
                          </td>
                        ))}
                      </td>
                    </td>
                  </tr>
                  <div>
                    <table className="pluginTable">
                      <tr>
                        <td>
                          <th className="Vmlihead">Vulnerability ID :</th>
                          <td
                            className="Svalue_drill"
                            style={{ marginRight: "20px" }}
                          >
                            {selectedOneData.map((data) => (
                              <td key={data} className="p-0">
                                {data && data.vulnerabilityId
                                  ? data.vulnerabilityId
                                  : "---"}
                              </td>
                            ))}
                          </td>
                        </td>
                      </tr>
                    </table>
                    <table style={{ display: "flex", flexDirection: "column" }}>
                      <tr>
                        <td>
                          <th className="cvssScoreStyle">Base Score :</th>
                          <td className="Svalue_drill clickable_Id temporal-score">
                            {selectedOneData.map((data, index) => {
                              const score =
                                data && data.baseScore ? data.baseScore : 0;
                              return (
                                <td
                                  key={index}
                                  className="p-0 clickable_Id temporal-score"
                                >
                                  {score === 0 ? (
                                    <span>{score}</span>
                                  ) : (
                                    <a
                                      data-testid="cvss-base-score"
                                      className="clickable_Id"
                                      onClick={() =>
                                        handleShowAccordian(
                                          VulIdToShow,
                                          BaseScoreShow,
                                          "Base Score",
                                          ip,
                                          scanId
                                        )
                                      }
                                    >
                                      {score}
                                    </a>
                                  )}
                                </td>
                              );
                            })}
                          </td>
                        </td>

                        {!isDI && (
                          <td>
                            <th className="cvssScoreStyle temporalalign">
                              Temporal Score :
                            </th>
                            <td className="Svalue_drill temporal-score">
                              {selectedOneData.map((data) => (
                                <td key={data} className="p-0 ">
                                  {data && data.temporalScore
                                    ? data.temporalScore
                                    : 0}
                                </td>
                              ))}
                            </td>
                          </td>
                        )}
                        <td>
                          <th className="cvssScoreStyle">
                            {" "}
                            Exploitability Score :
                          </th>
                          <td className="Svalue_drill temporal-score">
                            {/* <a
                                onClick={() =>
                                  handleShowAccordian(
                                    pluginIdToShow,
                                    cvssV2ScoreToShow,
                                    "cvssV2",
                                    ip,
                                    scanId
                                  )
                                }
                                style={{ marginRight: "20px" }}
                              >
                             
                              </a> */}
                            {selectedOneData.map((data) => (
                              <td key={data} className="p-0">
                                {data && data.exploitabilityScore
                                  ? data.exploitabilityScore
                                  : 0}
                              </td>
                            ))}
                          </td>
                        </td>

                        <td>
                          <th className="Vmlihead">Severity :</th>
                          <td
                            className="Svalue_drill"
                            style={{ marginRight: "20px" }}
                          >
                            {selectedOneData.map((data) => (
                              <td key={data} className="p-0 text-capitalize">
                                {data && data.severity}
                              </td>
                            ))}
                          </td>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <th className="Vmlihead">Current version :</th>
                          <td
                            className="Svalue_drill"
                            style={{ marginRight: "20px" }}
                          >
                            {selectedOneData.map((data) => (
                              <td key={data} className="p-0 text-capitalize">
                                {data && data.currentVersion}
                              </td>
                            ))}
                          </td>
                        </td>
                        <td>
                          <th className="Vmlihead">Fixed version :</th>
                          <td
                            className="Svalue_drill"
                            style={{ marginRight: "20px" }}
                          >
                            {selectedOneData.map((data) => (
                              <td key={data} className="p-0 text-capitalize">
                                {data && data.fixedVersion}
                              </td>
                            ))}
                          </td>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div>
                  <ChatBotAI
                    passTitle="SBOM"
                    passPlugin={selectedOneData.map((data) =>
                      data && data?.vulnerabilityId
                        ? data?.vulnerabilityId
                        : "Not Available"
                    )}
                    passCVEID={selectedOneData.map((data) =>
                      data && data?.relatedVulnerabilityId
                        ? data?.relatedVulnerabilityId
                        : "Not Available"
                    )}
                    passData={selectedOneData.map((data) =>
                      data && data?.relatedVulnerabilityDescription
                        ? data?.relatedVulnerabilityDescription
                        : "Not Available"
                    )}
                  />
                </div>
              </div>
              <div className="meanpop-wrap meanpop-subhead scrollable-containersbom">
                {selectedOneData ? (
                  <table>
                    <tbody>
                      {selectedOneData.map((data, index) => (
                        <tr key={index}>
                          {/* for cveid need to write condition ..... */}
                          <td className="pluginalign">CVE ID</td>
                          <td className="pluginalign">:</td>
                          <td className="display-content Svalue_drill">
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {data && data?.relatedVulnerabilityId ? (
                                data?.relatedVulnerabilityId.length > 0 ? (
                                  data?.relatedVulnerabilityId
                                    .split(",")
                                    .map((relatedVulnerabilityId, cveIndex) => {
                                      const epssScore =
                                        epssMap[relatedVulnerabilityId];
                                      const tooltipClass =
                                        severityClassMap[epssSeverity] || "";
                                      return (
                                        <div
                                          key={cveIndex}
                                          onMouseEnter={() =>
                                            handleEpssScore(
                                              relatedVulnerabilityId
                                            )
                                          }
                                          style={{ marginRight: 8 }}
                                        >
                                          <span
                                            className="cveIdStyle"
                                            onMouseEnter={() =>
                                              handleEpssScore(
                                                relatedVulnerabilityId
                                              )
                                            }
                                          >
                                            {epssScore ? (
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={(props) => (
                                                  <Tooltip
                                                    {...props}
                                                    className={`tooltip-drill-common ${tooltipClass}`}
                                                    id="tooltip-top"
                                                  >
                                                    {`EPSS - ${epssScore}`}
                                                  </Tooltip>
                                                )}
                                              >
                                                <span
                                                  className="cveIdStyle hover_Id px-2"
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  {relatedVulnerabilityId}
                                                </span>
                                              </OverlayTrigger>
                                            ) : (
                                              <span
                                                className="cveIdStyle hover_Id px-2"
                                                style={{ cursor: "pointer" }}
                                              >
                                                {relatedVulnerabilityId}
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                      );
                                    })
                                ) : (
                                  <span className="hover_Id px-2">
                                    Not Available
                                  </span>
                                )
                              ) : (
                                <span className="hover_Id px-2">
                                  Not Available
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}

                      <tr>
                        <td className="pluginalign">CVE ID Description </td>
                        <td className="pluginalign">:</td>
                        {selectedOneData.map((data, index) => (
                          <td key={index} className="display-content">
                            {data && data?.relatedVulnerabilityDescription
                              ? data?.relatedVulnerabilityDescription
                              : "---"}
                          </td>
                        ))}
                      </tr>

                      {/* <tr>
                      <td className="pluginalign">Synopsis</td>
                      <td className="pluginalign">:</td>
                      {selectedOneData.map((data, index) => (
                        <td key={index} className="display-content">
                          {data && data.synopsis ? data.synopsis : "---"}
                        </td>
                      ))}
                    </tr> */}
                      <tr>
                        <td className="pluginalign">Description</td>
                        <td className="pluginalign">:</td>
                        {selectedOneData.map((data, index) => (
                          <td key={index} className="display-content">
                            {data && data?.description
                              ? data?.description
                              : "---"}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="pluginalign">ID</td>
                        <td className="pluginalign">:</td>
                        {selectedOneData.map((data, index) => (
                          <td key={index} className="display-content">
                            {data && data.id ? data.id : "---"}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <div className="">No Data Available</div>
                )}
              </div>
            </div>
          )}

          {state.modalAccordian ? (
            <DrillDownAccordion
              enableSpinner={enableSpinner}
              data={csvData}
              modalBody={true}
              accordionFalse={accordionFalse}
              pluginId={state.pluginIdToShow}
              cvssScore={state.cvssScoreToShow}
              version={state.version}
              sbompage={common?.offcanvasThreeState?.sbom}
              isDI={isDI}
            />
          ) : null}
        </CustomOffCanvasThree>
      </>
    );
  } else if (common.offcanvasThreeState.static === true) {
    const first_array = selectedOneData[0][0];
    const second_array = selectedOneData[0][1];
    const columns = [
      {
        Header: "Resource ID",
        accessor: "resourceId",
      },
      {
        Header: "Types",
        accessor: "type",
      },
    ];
    function getLimitResources(pageLimitresource) {
      getLimitResource(pageLimitresource);
    }
    function getPageResources(ResourcePageNumber) {
      getPageResource(ResourcePageNumber);
    }
    function handleOnSorting(column, headerSortingState) {
      const { sortingField, isDataSorted } = getSortingValues(
        columns,
        column,
        headerSortingState
      );
      handleOnSortingResDrill &&
        handleOnSortingResDrill(sortingField, isDataSorted);
    }
    return (
      <>
        <CustomOffCanvasThree
          className="custom-off-canvas drilldownThree"
          classNameOffcanvas={classNameOffcanvas}
        >
          <div
            className={
              common.offcanvasThreeState.title === "trmg"
                ? ""
                : "meantimewrap custom_scroll"
            }
          >
            <div className="meanpop-head">
              {" "}
              {/* <h3 className="flowhead" id="issue_summary">{common.offcanvasThreeState.title}</h3> */}
            </div>
            <div
              className="meanpop-subhead drilldown2 "
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
              }}
            >
              <table>
                <tbody>
                  <tr>
                    <td className="pluginalign">
                      <span>Rule</span>
                    </td>
                    <td className="pluginalign">:</td>
                    <td>
                      <span
                        className="Svalue_drill trmgDD3DF"
                        style={{ textTransform: "none" }}
                      >
                        {first_array.ruleName ? first_array.ruleName : "-"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="pluginalign">
                      <span>Description</span>
                    </td>
                    <td className="pluginalign">:</td>
                    <td>
                      <span
                        className="Svalue_drill trmgDD3DF"
                        style={{ textTransform: "none" }}
                      >
                        {first_array.description
                          ? first_array.description
                          : "-"}
                      </span>
                    </td>
                  </tr>
                  {common.offcanvasThreeState.title === "circular9" ? (
                    <tr>
                      <td className="pluginalign">
                        <span>Circular 09 Reference</span>
                      </td>
                      <td className="pluginalign">:</td>
                      <td>
                        <span
                          className="Svalue_drill trmgDD3DF"
                          style={{ textTransform: "none" }}
                        >
                          {first_array.article ? first_array.article : "-"}
                        </span>
                        {first_array.article ? (
                          <a onClick={() => handleShowManage()} data-testid="drilldown-manage-link">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip>Click here for more details</Tooltip>
                              }
                            >
                              <span className="mx-1">
                                <FaInfoCircle
                                  className="faInfoCircleStyle"
                                  size={15}
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                />
                              </span>
                            </OverlayTrigger>
                          </a>
                        ) : null}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>

              <ChatBotAI
                passTitle="Circular9"
                passRule={
                  first_array && first_array.ruleName
                    ? first_array.ruleName
                    : "Not Available"
                }
                passDes={
                  first_array && first_array.description
                    ? first_array.description
                    : "Not Available"
                }
                passTypes={second_array.map((data) =>
                  data && data.type ? data.type : "Not Available"
                )}
              />
            </div>
            <div className="meanpop-resource">
              {selectedData ? (
                <>
                  <CompleteTableData
                    data={second_array}
                    columns={columns}
                    issearch={true}
                    curentPageNumber={ResourcePageNumber}
                    pageLimit={pageLimitresource}
                    onPageLimitChange={getLimitResources}
                    onPageNoChange={getPageResources}
                    totalPageCount={ResourcefinalPageCount}
                    listCount={ResourcelistCount}
                    onSorting={handleOnSorting}
                    headerSortingState={headerSortingState}
                    scrollClass={"trmgDrillTable"}
                    isLoading={tableLoading}
                  />
                </>
              ) : (
                <div className="">No Data Available</div>
              )}
            </div>
          </div>
        </CustomOffCanvasThree>
        <CustomModal
          modalOpen={state.modalBodyManage}
          modalBody={() =>
            modalBodyManage(first_array.article, first_array.clause)
          }
          modalHide={handleCloseManage}
          closeBtn={true}
          closeBtnFuc={handleCloseManage}
          size={"lg"}
        />
      </>
    );
  } else if (common.offcanvasThreeState.level === true) {
    if (!Array.isArray(selectedData) || selectedData.length === 0) {
      return <p>No data available</p>;
    }
    const data = selectedData[0].data;
    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${day}/${month}/${year}, ${hours}:${minutes}`;
    }
    return (
      <>
        <CustomOffCanvasThree className="custom-off-canvas drilldownThree">
          <div className="meantimewrap custom_scroll meanpop-resource">
            {Object.keys(data).map((group) => (
              <div key={group}>
                <h3 className="gridtitleflowMetrics">Group: {group}</h3>
                {Array.isArray(data[group]) && data[group].length > 0 ? (
                  <div className="mini-model-panal">
                    <table className="mini-model-table">
                      <thead>
                        <tr>
                          <th>Comment By</th>
                          <th>Time Stamp</th>
                          <th className="text-center">Comment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data[group].map((comment, index) => (
                          <tr key={index}>
                            <td>{comment.commentBy}</td>
                            <td className="text-center">
                              {formatDate(comment.timeStamp)}
                            </td>
                            <td>{comment.comment}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="">No Data Available</div>
                )}
              </div>
            ))}
          </div>
        </CustomOffCanvasThree>
      </>
    );
  } else if (common.offcanvasThreeState.sbom === true) {
    return (
      <>
        <h4>Nothing</h4>
      </>
    );
  } else if (common.offcanvasThreeState.isCustomizeDrilldown === true) {
    return (
      <CustomOffCanvasThree className="custom-off-canvas drilldownThree">
        <>{selectedData}</>
      </CustomOffCanvasThree>
    );
  } else {
    if (selectedData.length > 0) {
      return (
        <>
          <CustomOffCanvasThree className="custom-off-canvas drilldownThree">
            <div className="meantimewrap ">
              <table>
                <tbody>
                  <tr>
                    <th className="thirdflowSummaryhead d-flex">
                      <th
                        className="flowhead thirdflowSummaryTitle"
                        id="issue_summary"
                        style={{ fontSize: "16px" }}
                      >
                        Issue Summary:
                      </th>
                      <td style={{ fontWeight: "normal", fontSize: "16px" }}>
                        {selectedData[0].data.summary}
                      </td>
                    </th>
                  </tr>
                </tbody>
              </table>

              <div className="meanpop-subhead">
                <table className="table drilldownThreetitle">
                  <tr>
                    <th scope="row">
                      Jira Issue Key:
                      <span className="Svalue_drill">
                        {selectedData[0].data.jiraKey}
                      </span>
                    </th>

                    <th scope="row">
                      Current Status:
                      <span className="Svalue_drill">
                        {selectedData[0].data.status}
                      </span>
                    </th>

                    <th scope="row">
                      Category:
                      <span className="fontDrillThree Svalue_drill">
                        {selectedData[0].data.priority}
                      </span>
                    </th>
                  </tr>
                </table>
              </div>

              <div className="meanpop-wrap">
                {selectedData ? (
                  <table
                    className="thirdissuetabletitle thirdissuetable meantable"
                    id="issue_summary_drill"
                  >
                    <tr>
                      <th>Issue Assignee</th>
                      <td>{selectedData[0].data.assignee}</td>
                    </tr>
                    <tr>
                      <th>Issue Reporter</th>
                      <td>{selectedData[0].data.reportedBy}</td>
                    </tr>
                    <tr>
                      <th>Created Date</th>
                      <td>{EpochtoDate(selectedData[0].data.createdDate)}</td>
                    </tr>
                    <tr>
                      <th>Last Modified Date</th>
                      <td>{EpochtoDate(selectedData[0].data.updatedDate)}</td>
                    </tr>
                    <tr>
                      <th>Last Modified by</th>
                      <td>{selectedData[0].data.displayName}</td>
                    </tr>
                    <tr>
                      <th>Last Modified in Sprint</th>
                      <td>{selectedData[0].data.currentSprint}</td>
                    </tr>
                    <tr>
                      <th>Sprints Traversed</th>
                      <td>
                        {selectedData[1].data
                          ? selectedData[1].data.join(", ")
                          : ""}
                      </td>
                    </tr>
                  </table>
                ) : (
                  <div className="">No Data Available</div>
                )}
              </div>
            </div>
          </CustomOffCanvasThree>
        </>
      );
    }
  }
};

DrillDownOffCanvasThree.propTypes = {
  getPageResource: PropTypes.func.isRequired,
  getLimitResource: PropTypes.func.isRequired,
  Loading: PropTypes.bool,
  handleOnSortingResDrill: PropTypes.func.isRequired,
  headerSortingState: PropTypes.object,
  tableLoading: PropTypes.bool,
  className: PropTypes.String,
};

DrillDownOffCanvasThree.defaultProps = {
  Loading: false,
  tableLoading: false,
  headerSortingState: {},
};

export default memo(DrillDownOffCanvasThree);
